import { useLanguages } from "@hooks/useLanguages";
import { Language } from "@types";
import { DrawerClasses, LanguageSelector, LanguageSelectorClasses, LanguageValue } from "kz-ui-sdk";
import { useTranslation } from "react-i18next";

interface LanguageSelectProps {
  onLanguageChange?: (language: Language) => void;
  className?: string;
  classes?: LanguageSelectorClasses["classes"];
  title?: string;
  closeOnSelect?: boolean;
  drawerClasses?: DrawerClasses["classes"];
  hiddenComponent?: React.ReactNode;
}

const LanguageSelect = ({
  onLanguageChange,
  className = "!w-fit max-w-sm",
  classes,
  title,
  closeOnSelect,
  drawerClasses,
  hiddenComponent = <span></span>,
}: LanguageSelectProps) => {
  const { t } = useTranslation();
  const { currentLanguage, languages, changeLanguage, isMultiLanguage } = useLanguages();

  const handleOnChangeLanguage = (option: LanguageValue) => {
    changeLanguage(option.code as Language);
    onLanguageChange?.(option.code as Language);
  };

  if (!isMultiLanguage) return hiddenComponent;

  return (
    <LanguageSelector
      languages={languages}
      defaultValue={languages.find((lang) => lang.code === currentLanguage.code)}
      variant="ghost"
      className={className}
      size="lg"
      closeOnSelect={closeOnSelect}
      drawerClasses={drawerClasses}
      onChange={(option) => handleOnChangeLanguage(option)}
      title={title ?? t("language")}
      classes={classes}
    />
  );
};

export default LanguageSelect;
